import { MeshBundleEntryV2Gltf } from '@editor/interfaces/meshFiles'
import { MeshLODMetadata, MeshTileDebug, disposeMaterial } from '@infraloop/common'
import * as Sentry from '@sentry/react'
import { BufferGeometry, Group, Material, Mesh } from 'three'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'

const loader = new GLTFLoader()

/**
 * MeshTileGltf class extending MeshTile to manage gltf tiles.
 * This class does not mean a speciific Mesh, but rather a container to manage
 * meshes within the tile for optimized rendering.
 */
class MeshTileGltf extends MeshTileDebug<MeshBundleEntryV2Gltf> {
  async loadLOD(lodIndex: number) {
    if (lodIndex < 0 || lodIndex >= this.userData.lods.length || lodIndex === this.currentLOD) return

    // Hide all children not of the desired LOD
    // let loadedIndex = -1
    // this.children.forEach((child, index) => {
    //   const childLodMetadata = child.userData as MeshLODMetadata
    //   if (childLodMetadata.lod === lodIndex) {
    //     loadedIndex = index
    //   }
    // })

    // // If already loaded, jsut show it and update currentLOD
    // if (loadedIndex > -1) {
    //   this.currentLOD = lodIndex
    //   this.children.forEach((child, index) => {
    //     child.visible = index === loadedIndex && child !== this.boundingBoxHelper
    //   })
    //   return
    // }

    // fetch(this.urlGenerator(this.userData.lods[lodIndex]))
    //   .then((response) => response.arrayBuffer())
    //   .then((data) => {
    //     this.tempData[lodIndex] = data
    //     this.tempData.forEach((_, index) => {
    //       if (index !== lodIndex) {
    //         delete this.tempData[index]
    //       }
    //     })

    //     return this.loader.parseAsync(data, '')
    //   })
    //   .then((g) => {
    //     // g.scene.userData = {
    //     //   meshId: this.userData.id,
    //     //   lod: lodIndex,
    //     // } as MeshLODMetadata
    //     // this.add(g.scene)
    //     this.currentLOD = lodIndex

    //     // Remove other LODs from memory to save space
    //     // this.children.forEach((child) => {
    //     //   const childLodMetadata = child.userData as MeshLODMetadata
    //     //   if (childLodMetadata.lod !== lodIndex) {
    //     //     child.traverse((grandChild) => {
    //     //       if (grandChild instanceof Mesh && grandChild.geometry instanceof BufferGeometry) {
    //     //         grandChild.geometry.dispose()
    //     //         if (Array.isArray(grandChild.material)) {
    //     //           grandChild.material.forEach((mat) => (mat instanceof Material ? mat.dispose() : null))
    //     //         } else if (grandChild.material instanceof Material) {
    //     //           grandChild.material.dispose()
    //     //         }
    //     //       }
    //     //     })
    //     //     this.remove(child)
    //     //     delete this.tempData[childLodMetadata.lod]
    //     //   }
    //     // })
    //   })
    //   .catch((err) => {
    //     console.error('Failed to load LOD file:', this.userData.lods[lodIndex], err)
    //     Sentry.captureException(err, {
    //       extra: { url: this.userData.lods[lodIndex] },
    //     })
    //   })

    const fileUrl = await this.urlGenerator(this.userData.lods[lodIndex])

    // Load the LOD file
    await loader
      .loadAsync(fileUrl)
      .then((g) => {
        g.scene.userData = {
          meshId: this.userData.id,
          lod: lodIndex,
        } as MeshLODMetadata

        this.add(g.scene)
        this.currentLOD = lodIndex

        // Remove other LODs from memory to save space
        this.children.forEach((child) => {
          if (!(child instanceof Group)) {
            return
          }

          const childLodMetadata = child.userData as MeshLODMetadata
          if (childLodMetadata.lod !== lodIndex) {
            this.remove(child)
            child.traverse((grandChild) => {
              if (grandChild instanceof Mesh && grandChild.geometry instanceof BufferGeometry) {
                grandChild.geometry.dispose()
                if (grandChild.material instanceof Material || Array.isArray(grandChild.material))
                  disposeMaterial(grandChild.material)
              }
            })
          }
        })

        // Hide all children not of the desired LOD
        // this.children.forEach((child) => {
        //   child.visible = child.userData.lod === lodIndex && child !== this.boundingBoxHelper
        // })
      })
      .catch((err) => {
        Sentry.captureException(err, {
          extra: { url: fileUrl, meshId: this.userData.id, lodIndex },
        })
      })
  }
}

export default MeshTileGltf
